import classnames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { DATE_FORMAT_DD_MMM_YYYY } from '@/helpers/common';
import { MyTooltip } from '@/webkit/MyTooltip';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { EMPTY_DASH } from '@/helpers/constants';
import { EmptyContent } from '@/components/EmptyContent';
import { Preloader } from '@/components/Preloader';
import IconTooltip from './icon_tooltip.svg';
import { REPAYMENT_STATUSES } from '../index';
import s from './index.module.scss';

export const RepScheduleList = ({ data, isLoading }) => {
  const { t } = useTranslation('repayment_schedule');
  const REPAYMENT_STATUSES_T = REPAYMENT_STATUSES(t);

  if (isLoading) {
    return <Preloader className={s.preloader} />;
  }

  if (!isLoading && !data?.length) {
    return (
      <div className={s.empty}>
        <EmptyContent
          title={t('no_repayments_yet')}
          text={t('repayment_will_appear')}
        />
      </div>
    );
  }

  return (
    <div className={s.wrapper}>
      <div className={s.list}>
        {data.map((item, idx) => {
          return (
            <div className={s.list__item} key={idx}>
              <div className={s.row}>
                <div className={s.tooltip}>
                  <span className="f-small-regular">{t('due_date')}</span>
                  <MyTooltip
                    theme="dark"
                    delay={500}
                    renderContent={() => (
                      <div
                        className={classnames(
                          'f-small-regular',
                          s.tooltip_content,
                        )}
                      >
                        <Trans
                          ns="repayment_schedule"
                          i18nKey="scheduled_payments_can_adjusted"
                          components={{
                            linkTerms: (
                              <MyLink
                                href={APP_LINKS.helpLoanTerms()}
                                isExternal
                                underline
                              />
                            ),
                          }}
                        />
                      </div>
                    )}
                    renderElement={() => (
                      <div className={s.tooltip_icon}>
                        <img
                          src={IconTooltip}
                          alt="tooltip"
                          width={16}
                          height={16}
                        />
                      </div>
                    )}
                  />
                </div>
                <div className="f-small-accent">
                  {prettyDate(item.deadline, DATE_FORMAT_DD_MMM_YYYY)}
                </div>
              </div>
              <div className={s.row}>
                <div className="f-small-regular">{t('amount')}</div>
                <div className="f-small-accent">
                  {prettyFloatMoney(item.total_amount, {
                    decimalPlaces: 2,
                  })}
                </div>
              </div>
              <div className={s.row}>
                <div className="f-small-regular">{t('payment_date')}</div>
                <div className="f-small-accent">
                  {item.payment_date
                    ? prettyDate(item.payment_date, DATE_FORMAT_DD_MMM_YYYY)
                    : EMPTY_DASH}
                </div>
              </div>
              <div className={s.row}>
                <div className="f-small-regular">{t('payment_received')}</div>
                <div className="f-small-accent">
                  {item.payment_received
                    ? prettyFloatMoney(item.payment_received, {
                        decimalPlaces: 2,
                      })
                    : EMPTY_DASH}
                </div>
              </div>
              <div className={s.row}>
                <div className="f-small-regular">{t('status')}</div>
                <div
                  className={classnames(
                    s.status,
                    item.status,
                    'f-small-accent',
                  )}
                >
                  {REPAYMENT_STATUSES_T[item.status].label}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};